/* eslint-disable import/first -- setPlatform must run before store/api and i18n are loaded */
import { setPlatform } from 'shared/platform/adapter';

// Платформенный адаптер для shared (store/api при переносе в shared будут использовать его)
setPlatform({
  storage: typeof localStorage !== 'undefined' ? localStorage : undefined,
  sessionStorage: typeof sessionStorage !== 'undefined' ? sessionStorage : undefined,
  navigateToLogin: () => { if (typeof window !== 'undefined') window.location.href = '/login'; },
  getLanguage: () => 'en',
  shouldRedirectToLogin: () => {
    if (typeof window === 'undefined') return true;
    const path = window.location.pathname;
    return !['/feed', '/video/', '/route/'].some(p => path.startsWith(p)) && path !== '/login' && !path.startsWith('/auth/');
  },
});
import i18n from './utils/i18n';
setPlatform({ getLanguage: () => i18n.language || 'en' });

import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import App from './App';
import { store } from './store/store';
import './styles/main.css';
import { getUiScale, applyUiScale } from './utils/ui';
import packageJson from '../package.json';

/* eslint-disable no-undef */
// Устанавливаем public path для динамических чанков (react-player и др.)
// чтобы они грузились от корня, а не относительно текущего маршрута
if (typeof __webpack_public_path__ !== 'undefined') {
  __webpack_public_path__ = '/';
}

// Обработка ошибок загрузки чанков - автоматическая перезагрузка при ChunkLoadError
window.addEventListener('error', (event) => {
  if (event.message && event.message.includes('ChunkLoadError')) {
    console.warn('ChunkLoadError detected, reloading page in 2 seconds...');
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  }
}, true);

// Обработка необработанных промисов (для динамических импортов)
window.addEventListener('unhandledrejection', (event) => {
  const error = event.reason;
  if (error && (error.name === 'ChunkLoadError' || error.message?.includes('Loading chunk'))) {
    console.warn('ChunkLoadError in promise, reloading page in 2 seconds...');
    event.preventDefault();
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  }
});

// Применяем пользовательский масштаб UI из localStorage при старте
try {
  const baseScale = getUiScale();
  // На мобильных устройствах уменьшаем масштаб на 15% (0.85)
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
                   (window.matchMedia && window.matchMedia('(max-width: 768px)').matches);
  const mobileScale = isMobile ? 0.85 : 1.0;
  const finalScale = baseScale * mobileScale;
  applyUiScale(finalScale);
  
  // Реагируем на изменения из других вкладок
  window.addEventListener('storage', (e) => {
    if (e.key === 'ui.scale') {
      const newBaseScale = getUiScale();
      const newFinalScale = newBaseScale * mobileScale;
      applyUiScale(newFinalScale);
    }
  });
} catch (e) {
  // noop
}

// Отображаем версию фронтенда в консоли для отладки обновлений
const version = packageJson.version || '1.0.0';
const loadTime = new Date().toISOString();

// Пытаемся найти hash из загруженных скриптов
let buildHash = 'unknown';
if (typeof document !== 'undefined') {
  const scripts = document.getElementsByTagName('script');
  for (let i = 0; i < scripts.length; i++) {
    const src = scripts[i].src;
    if (src && src.includes('/static/js/')) {
      // Извлекаем hash из имени файла (например, main.abc123.js -> abc123)
      const match = src.match(/\/static\/js\/[^.]+\.([^.]+)\.js/);
      if (match && match[1]) {
        buildHash = match[1].substring(0, 8); // Берем первые 8 символов
        break;
      }
    }
  }
}

console.log(
  `%c🚀 Travel Map Platform Frontend`,
  'color: #3b82f6; font-size: 14px; font-weight: bold;'
);
console.log(
  `%cVersion: ${version} | Load Time: ${loadTime}`,
  'color: #6b7280; font-size: 12px;'
);
console.log(
  `%cBuild Hash: ${buildHash}`,
  'color: #9ca3af; font-size: 11px;'
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <I18nextProvider i18n={i18n}>
          <HelmetProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </HelmetProvider>
        </I18nextProvider>
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>
);
